import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { LoginPage } from "pages/auth/login";
import { HomePage } from "pages/dashboard/home";
import { Error404 } from "pages/error/error_404";
import { DashboardLayout } from "components/layout/dashboard_layput";
import { SavePage } from "pages/dashboard/save";
import { ImportExportPage } from "pages/dashboard/import_export";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "/import-export",
        element: <ImportExportPage />,
      },

      {
        path: "/save-load",
        element: <SavePage />,
      },
      {
        path: "*",
        element: <Error404 />,
      },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  { path: "*", element: <Error404 /> },
]);

export const WebRoutes = () => {
  return <RouterProvider router={router} />;
};
